import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Layout/Header';
import { Footer } from './components/Layout/Footer';
import { Sidebar } from './components/Navigation/Sidebar';
import { ScrollToTop } from './components/ScrollToTop';
import { LandingPage } from './pages/LandingPage';
import { EthicsPage } from './pages/EthicsPage';
import { PromptEngineeringPage } from './pages/PromptEngineeringPage';
import { PromptLibraryPage } from './pages/PromptLibraryPage'; //new page
import { PodcastsPage } from './pages/PodcastsPage';
import { NewsletterPage } from './pages/NewsletterPage';
import { AIFluencyPage } from './pages/AIFluencyPage';
import { AgenticAIPage } from './pages/AgenticAIPage';
import { GlobalProvider } from './context/GlobalContext';
import './App.css';

function App() {
  return (
    <GlobalProvider>
      <Router>
        <div className="app">
          <a href="#main-content" className="skip-link">
            Skip to main content
          </a>
          <ScrollToTop />
          <Header />
          <Sidebar />
          <main id="main-content" className="main-content">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/ai-fluency" element={<AIFluencyPage />} />
              <Route path="/agentic-ai" element={<AgenticAIPage />} />
              <Route path="/ethics" element={<EthicsPage />} />
              <Route path="/prompt-engineering" element={<PromptEngineeringPage />} />
              <Route path="/prompt-library" element={<PromptLibraryPage />} />
              <Route path="/podcasts" element={<PodcastsPage />} />
              <Route path="/newsletter" element={<NewsletterPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </GlobalProvider>
  );
}

export default App;